import { FC, ReactNode } from 'react';
import { useLocation } from 'react-router';
import { FaSyncAlt } from 'react-icons/fa';
import Tabs from 'components/tabs/Tabs';
import Tab from 'components/tabs/Tab';
import { useActiveClientContext } from 'store/active-client';
import { buildClientUrl } from 'utils/helpers/client';
import styled from 'styled-components';

interface ITabNavProps {
  tabs: {
    to?: string;
    onClick?: () => void;
    label?: string;
    onRefresh?: () => void;
    isExact?: boolean;
    notification?: ReactNode;
  }[];
}

const TabNavigation: FC<ITabNavProps> = ({ tabs }: ITabNavProps) => {
  const location = useLocation();
  const { client } = useActiveClientContext();
  return (
    <Tabs>
      {tabs.map((tab, index) => {
        if (tab.to && tab.label) {
          const to = buildClientUrl(tab.to, client);

          if (tab.onClick)
            return (
              <Tab
                key={index}
                isActive={tab.isExact ? location.pathname === to : location.pathname.includes(to)}
                onClick={tab.onClick}
              >
                <LabelContainer>
                  {tab.label}
                  {tab.notification && tab.notification}
                </LabelContainer>
              </Tab>
            );

          return (
            <Tab
              key={index}
              isActive={tab.isExact ? location.pathname === to : location.pathname.includes(to)}
              to={to}
            >
              <LabelContainer>
                {tab.label}
                {tab.notification && tab.notification}
              </LabelContainer>
            </Tab>
          );
        }
        if (tab.onRefresh) {
          return (
            <Tab
              key={index}
              className="refresh-button"
              isActive={false}
              onClick={tab.onRefresh}
            >
              <FaSyncAlt />
            </Tab>
          );
        }
        return null;
      })}
    </Tabs>
  );
};

export default TabNavigation;

const LabelContainer = styled.div`
  position: relative;
  display: inline-block;
`;
